import AlertHistorySkin from "./alert_history/skins";
import ControlProfileSkin from "./control_profile/skins";
import EventTimelineSkin from "./event_timeline/skins";
import ItemSummarySkin from "./item_summary/skins";
import JsonViewerSkin from "./json_viewer/skins";
import MonitorCardSkin from "./monitor_card/skins";
import SensorRulesSkin from "./sensor_rules/skins";
import StatusBoardSkin from "./status_board/skins";

export {
  AlertHistorySkin,
  ControlProfileSkin,
  EventTimelineSkin,
  ItemSummarySkin,
  JsonViewerSkin,
  MonitorCardSkin,
  SensorRulesSkin,
  StatusBoardSkin,
};

export const LIST_SKIN_REGISTRY = {
  alert_history: AlertHistorySkin,
  control_profile: ControlProfileSkin,
  event_timeline: EventTimelineSkin,
  item_summary: ItemSummarySkin,
  json_viewer: JsonViewerSkin,
  monitor_card: MonitorCardSkin,
  sensor_rules: SensorRulesSkin,
  status_board: StatusBoardSkin,
};

export function resolveSkinComponent(code) {
  return LIST_SKIN_REGISTRY[code] || MonitorCardSkin;
}
